import React from 'react';

import { Typography } from '@sravni/react-design-system';
import { SpecialOffers as SpecialUgcOffers } from '@sravni/react-ugc/lib/SpecialOffers';
import { useAbTestingSdk, useAnalytics, useStyles } from '@sravni/react-utils';
import { OFFERS_TABS_DEFAULT_ORDER } from '@sravni/ugc/lib/constants/SpecialOffersAndActions';

import { AB_NAME } from '../../pages/_app';
import commonStyles from '../../styles/common.module.scss';

const SpecialOffers = React.memo(() => {
  const { pushEvent } = useAnalytics();
  // TODO variant b
  const cx = useStyles(commonStyles);

  // TODO тестирование плитки, вариант А это текущий интерфейс (0 в сигме), вариант Б - плитки (1 в сигме)
  const abTestingSdk = useAbTestingSdk();
  const isBtest = abTestingSdk.checkExperimentVariant('915a75f8-efa7-4260', '1');

  return (
    <>
      <div className={commonStyles.wrapper}>
        {/* TODO variant b */}
        <div className={isBtest ? cx('inner', 'newInner') : cx('inner')}>
          <SpecialUgcOffers
            heading={<Typography.Heading level={2} />}
            headingType={'horizontal'}
            pushEvent={pushEvent}
            abName={AB_NAME}
            isWithButtons
            maxDesktopVisibleItems={4}
            tabs={OFFERS_TABS_DEFAULT_ORDER}
          />
        </div>
      </div>
    </>
  );
});

export default SpecialOffers;
